import {DeferLoadingStrategy} from '@spartacus/core';

export const LayoutConfig: object = {
  /**
   * Defines which CMS Content Slots are displayed in the frontend and how they are ordered.
   */
  deferredLoading: {
    strategy: DeferLoadingStrategy.DEFER,
    intersectionMargin: '50px',
  },
  layoutSlots: {
    header: {
      xs: {
        slots: [
          'CategoriesMenuSlot',
          'ReturnTo',
          'SiteLogo',
          'StaticSiteLogo',
          'DynamicHeading',
          'HelpIconSlot',
          'MiniCart',
          'UserMenu',
          'CountrySelector',
          'IframeCloseIcon',
          'SecureIconHeading',
          'SearchBox',
        ],
      },
      sm: {
        slots: [
          'ReturnTo',
          'SiteLogo',
          'StaticSiteLogo',
          'CategoriesMenuSlot',
          'SearchBox',
          'DynamicHeading',
          'HelpIconSlot',
          'MiniCart',
          'UserMenu',
          'CountrySelector',
          'IframeCloseIcon',
          'SecureIconHeading',
        ],
      },
      md: {
        slots: [
          'ReturnTo',
          'SiteLogo',
          'StaticSiteLogo',
          'CategoriesMenuSlot',
          'SearchBox',
          'DynamicHeading',
          'HelpIconSlot',
          'MiniCart',
          'UserMenu',
          'CountrySelector',
          'IframeCloseIcon',
          'SecureIconHeading',
        ],
      },
      lg: {
        slots: [
          'ReturnTo',
          'SiteLogo',
          'StaticSiteLogo',
          'CategoriesMenuSlot',
          'SearchBox',
          'DynamicHeading',
          'HelpIconSlot',
          'MiniCart',
          'UserMenu',
          'CountrySelector',
          'IframeCloseIcon',
          'SecureIconHeading',
        ],
      },
    },
    navigation: {
      xs: {
        slots: ['TestEnvironmentBanner', 'CustomNavigationBar'],
      },
      sm: {
        slots: ['TestEnvironmentBanner', 'CustomNavigationBar'],
      },
      md: {
        slots: ['TestEnvironmentBanner', 'CustomNavigationBar'],
      },
      lg: {
        slots: ['TestEnvironmentBanner', 'CustomNavigationBar'],
      },
    },
    footer: {
      xs: {
        slots: ['Footer', 'FooterSiteLogoPosition'],
      },
      sm: {
        slots: ['Footer', 'FooterSiteLogoPosition'],
      },
      md: {
        slots: ['Footer', 'FooterSiteLogoPosition'],
      },
      lg: {
        slots: ['Footer', 'FooterSiteLogoPosition'],
      },
    },
    checkoutFooter: {
      xs: {
        slots: ['CheckoutFooter', 'CheckoutFooterSiteLogoPosition'],
      },
      sm: {
        slots: ['CheckoutFooterSiteLogoPosition', 'CheckoutFooter'],
      },
      md: {
        slots: ['CheckoutFooterSiteLogoPosition', 'CheckoutFooter'],
      },
      lg: {
        slots: ['CheckoutFooterSiteLogoPosition', 'CheckoutFooter'],
      },
    },
    LandingPageTemplate: {
      slots: ['Section1', 'Section2A', 'Section2B', 'Section2C', 'Section2D', 'Section3', 'Section4', 'Section5'],
    },
    ContentPageTemplate: {
      slots: ['Section1', 'Section2A', 'Section2B'],
    },
    CategoryPageTemplate: {
      pageFold: 'Section2',
      slots: ['Section1', 'Section2', 'Section3'],
    },
    ProductListPageTemplate: {
      slots: ['ProductListSlot'],
    },
    SearchResultsGridPageTemplate: {
      xs: {
        slots: [
          'SearchCustomResultList',
          'SearchCustomPagination',
          'SearchSupportWidget',
          'HeadlessCommerceSearchWebComponent',
        ],
      },
      sm: {
        slots: [
          'SearchCustomResultList',
          'SearchCustomPagination',
          'SearchSupportWidget',
          'HeadlessCommerceSearchWebComponent',
        ],
      },
      md: {
        slots: [
          'SearchCustomResultList',
          'SearchCustomPagination',
          'SearchSupportWidget',
          'HeadlessCommerceSearchWebComponent',
        ],
      },
      lg: {
        slots: [
          'SearchCustomResultList',
          'SearchCustomPagination',
          'SearchSupportWidget',
          'HeadlessCommerceSearchWebComponent',
        ],
      },
    },
    ProductDetailsPageTemplate: {
      slots: [
        'Hero',
        'FeaturesAndBenefits',
        'PlansAndPricing',
        'TechnicalInformation',
        'Resources',
        'Review',
        'Publisher',
        'ProductSupportWidget',
      ],
    },
    ProductConfiguratorPageTemplate: {
      slots: ['Section1', 'SupportWidget'],
    },
    CartPageTemplate: {
      // TopContent = Filled Cart
      slots: ['TopContent', 'LoadingContent', 'EmptyCartMiddleContent', 'SupportWidget'],
    },
    AccountPageTemplate: {
      slots: ['BodyContent', 'SideContent'],
    },
    LoginPageTemplate: {
      slots: ['LeftContentSlot', 'RightContentSlot'],
    },
    ErrorPageTemplate: {
      slots: ['TopContent', 'MiddleContent', 'BottomContent'],
    },
    OrderConfirmationPageTemplate: {
      slots: ['BodyContent', 'SideContent', 'SupportWidget'],
    },
    MultiStepCheckoutSummaryPageTemplate: {
      slots: ['BodyContent', 'SupportWidget'],
    },
    SupportFormPageTemplate: {
      slots: ['TopContent'],
    },
    OrderUpsellBundleCtaPageTemplate: {
      slots: ['Section1'],
    },
    ContactSupportCtaPageTemplate: {
      slots: ['Section1'],
    },
    ContactPartnerCtaPageTemplate: {
      slots: ['Section1'],
    },
    ContactSalesRepCtaPageTemplate: {
      slots: ['Section1'],
    },
    VariantConfigurationTemplate: {
      header: {
        xs: {
          slots: [
            'ReturnTo',
            'SiteLogo',
            'StaticSiteLogo',
            'CategoriesMenuSlot',
            'SearchBox',
            'DynamicHeading',
            'HelpIconSlot',
            'MiniCart',
            'UserMenu',
            'CountrySelector',
            'IframeCloseIcon',
            'SecureIconHeading',
          ],
        },
        sm: {
          slots: [
            'ReturnTo',
            'SiteLogo',
            'StaticSiteLogo',
            'CategoriesMenuSlot',
            'SearchBox',
            'DynamicHeading',
            'HelpIconSlot',
            'MiniCart',
            'UserMenu',
            'CountrySelector',
            'IframeCloseIcon',
            'SecureIconHeading',
          ],
        },
        md: {
          slots: [
            'ReturnTo',
            'SiteLogo',
            'StaticSiteLogo',
            'CategoriesMenuSlot',
            'SearchBox',
            'DynamicHeading',
            'HelpIconSlot',
            'MiniCart',
            'UserMenu',
            'CountrySelector',
            'IframeCloseIcon',
            'SecureIconHeading',
          ],
        },
        lg: {
          slots: [
            'ReturnTo',
            'SiteLogo',
            'StaticSiteLogo',
            'CategoriesMenuSlot',
            'SearchBox',
            'DynamicHeading',
            'HelpIconSlot',
            'MiniCart',
            'UserMenu',
            'CountrySelector',
            'IframeCloseIcon',
            'SecureIconHeading',
          ],
        },
      },
      checkoutFooter: {
        xs: {
          slots: ['CheckoutFooter', 'CheckoutFooterSiteLogoPosition'],
        },
        sm: {
          slots: ['CheckoutFooter', 'CheckoutFooterSiteLogoPosition'],
        },
        md: {
          slots: ['CheckoutFooterSiteLogoPosition', 'CheckoutFooter'],
        },
        lg: {
          slots: ['CheckoutFooterSiteLogoPosition', 'CheckoutFooter'],
        },
      },
      lg: {
        slots: [
          'VariantConfigHeader',
          'VariantConfigMenu',
          'VariantConfigContent',
          'VariantConfigBottombar',
          'VariantConfigVariantCarousel',
          'SupportWidget',
        ],
      },
      slots: [
        'VariantConfigHeader',
        'VariantConfigContent',
        'VariantConfigBottombar',
        'VariantConfigVariantCarousel',
        'SupportWidget',
      ],
    },
  },
};
